import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["<div class=\"item-inner\"><button class=\"button button-fill back-button color-gray\">Quay l\u1EA1i</button></div>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["<div class=\"item-inner\"><button class=\"button button-fill send-button\">G\u1EEDi \u0111i</button></div>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/** @jsx $jsx */
import { $jsx } from 'framework7';
import Base from '../js/base';
export default (function (props, _ref) {
  var $update = _ref.$update,
      $ = _ref.$,
      $on = _ref.$on;
  var page_name = 'comment';
  var pn = "div[data-name=\"".concat(page_name, "\"]"); //Category values

  var ZERO = "0";
  var COLLEAGUE = 'colleague';
  var IDEA = 'idea';
  var OTHER = 'other';

  var SendButton = function SendButton(props, _ref2) {
    var $h = _ref2.$h;
    return function () {
      return $h(_templateObject());
    };
  };

  var BackButton = function BackButton(props, _ref3) {
    var $h = _ref3.$h;
    return function () {
      return $h(_templateObject2());
    };
  }; //Dom blocks


  var $intro, $colleague, $commentSolution, $idea, $other, $blockArray, $selectCategory, insertedCommentId;
  /**
   * CATEGORIES:
   * 0: blank
   * colleague
   * idea
   * other
   * -------------
   * BLOCKS:
   * intro-block
   * colleague-block
   * comment-solution-block
   * newidea-block
   * other-block
  */

  /**
   * Show block
  */

  var showBlock = function showBlock($block) {
    //Hide all
    $blockArray.map(function ($b) {
      return $b.addClass('display-none');
    }); //Show selected block

    $block.removeClass('display-none');
  };

  $on('pageAfterIn', function (e) {
    $intro = $(pn + ' .intro-block');
    $colleague = $(pn + ' .colleague-block');
    $commentSolution = $(pn + ' .comment-solution-block');
    $idea = $(pn + ' .newidea-block');
    $other = $(pn + ' .other-block');
    $selectCategory = $intro.find('select[name="category"]');
    $blockArray = [$intro, $colleague, $commentSolution, $idea, $other]; //Sau khi tải trang, hiển thị phần intro

    showBlock($intro); //Tuỳ thuộc chọn category nào sẽ hiển thị các block tương ứng

    $selectCategory.change(function (e) {
      var selectedValue = $selectCategory.val();

      switch (selectedValue) {
        case ZERO:
          //Hide everything except intro
          showBlock($intro);
          break;

        case COLLEAGUE:
          //
          showBlock($colleague);
          break;

        case IDEA:
          showBlock($idea);
          break;

        case OTHER:
          showBlock($other);
          break;

        default:
          showBlock($intro);
          break;
      }
    }); //Load danh sách tất cả nhân viên

    var interval = setInterval(function () {
      if (Base.initdataLoaded) {
        clearInterval(interval);
        var $select = $colleague.find('select[name="id_emp_victim"]');
        Base.initdata.emps.map(function (e) {
          return $select.append("<option value=\"".concat(e.id, "\">").concat(e.name, "</option>"));
        });
      }
    }, 1000); //Khi ấn quay lại, hiển thị intro

    var resetAll = function resetAll() {
      $selectCategory.val(ZERO);
      showBlock($intro);
      $(pn + ' textarea').val('');
      insertedCommentId = null;
    }; //Click nút back


    $(pn + ' .back-button').click(function (e) {
      return Base.app.dialog.confirm('Quay lại?', function () {
        return resetAll();
      });
    }); //Gửi góp ý đồng nghiệp

    $colleague.find('.send-button').click(function (e) {
      var data = Base.app.form.convertToData('.colleage-comment-form'); //Chọn category là Góp ý đồng nghiệp

      data.category = COLLEAGUE;
      if (data.comment.trim().length === 0) return false;

      if (data.id_emp_victim === '') {
        Base.app.dialog.alert('Hãy chọn người mà bạn muốn góp ý');
        return false;
      }

      Base.app.dialog.confirm('Bạn đã chắc chắn để gửi đi?', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var loader, rs;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loader = Base.app.dialog.preloader();
                _context.next = 3;
                return Base.api('Comment', 'post', data);

              case 3:
                rs = _context.sent;
                loader.close();

                if (!(rs.result !== 'success')) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", false);

              case 7:
                insertedCommentId = parseInt(rs.id); //Hiển thị form comment-solution

                showBlock($commentSolution);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }); //Gửi giải pháp

    $commentSolution.find('.send-button').click( /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
        var data, rs;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = Base.app.form.convertToData('.comment-solution-form'); //Không có giải pháp nào

                if (!(data.comment_solution.trim().length === 0)) {
                  _context2.next = 4;
                  break;
                }

                Base.app.dialog.confirm('Bạn chắc chắn là mình chưa có ý kiến gì?', function () {
                  Base.app.dialog.alert('Cảm ơn bạn. Chúng ta sẽ cùng xem xét vấn đề này nhé!', function () {
                    resetAll();
                  });
                });
                return _context2.abrupt("return", false);

              case 4:
                //Gửi lên id vừa thêm vào
                data.id = insertedCommentId;
                _context2.next = 7;
                return Base.api('Comment', 'updateSolution', data);

              case 7:
                rs = _context2.sent;
                Base.app.dialog.alert('Cảm ơn ý kiến của bạn.', function () {
                  showBlock($intro);
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }()); //Gửi ý tưởng mới

    $idea.find('.send-button').click(function (e) {
      var data = Base.app.form.convertToData('.newidea-form'); //Chọn category là Góp ý đồng nghiệp

      data.category = IDEA;
      if (data.comment.trim().length === 0) return false;
      Base.app.dialog.confirm('Xác nhận gửi?', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var loader, rs;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                loader = Base.app.dialog.preloader();
                _context3.next = 3;
                return Base.api('Comment', 'post', data);

              case 3:
                rs = _context3.sent;
                loader.close();

                if (!(rs.result !== 'success')) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return", false);

              case 7:
                Base.app.dialog.alert('Cảm ơn ý kiến/đóng góp của bạn rất nhiều!', function () {
                  showBlock($intro);
                });

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }); //Gửi về vấn đề khác

    $other.find('.send-button').click(function (e) {
      var data = Base.app.form.convertToData('.other-form'); //Chọn category là comment khác

      data.category = OTHER;
      if (data.comment.trim().length === 0) return false;
      Base.app.dialog.confirm('Xác nhận gửi?', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var loader, rs;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                loader = Base.app.dialog.preloader();
                _context4.next = 3;
                return Base.api('Comment', 'post', data);

              case 3:
                rs = _context4.sent;
                loader.close();

                if (!(rs.result !== 'success')) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt("return", false);

              case 7:
                insertedCommentId = parseInt(rs.id); //Hiển thị form comment-solution

                showBlock($commentSolution);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="${page_name}">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left"></div>
      <div class="title">Góp ý</div>
    </div>
  </div>
  <div class="page-content">
    <!-- Hiển thị khi load trang -->
    <div class="intro-block display-none">
      <div class="block block-strong no-margin">
        <p>Chào bạn,</p>
        <p>Đây là nơi bạn có thể góp ý trực tiếp với anh Tùng, chị Hà về bất kỳ về vấn đề gì. Tất cả góp ý của bạn đều vô cùng ý nghĩa cho Hà Xinh và sẽ được lưu lại một cách hệ thống để giúp lãnh đạo đánh giá và quản lý tốt hơn.</p>
        <p>Cảm ơn bạn.</p>
      </div>
      <div class="list no-margin">
        <ul>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">Bạn muốn gửi góp ý/ý kiến</div>
              <div class="item-input-wrap input-dropdown">
                <select name="category">
                  <option value="${ZERO}">Vui lòng chọn</option>
                  <option value="${COLLEAGUE}">Về đồng nghiệp</option>
                  <option value="${IDEA}">Ý tưởng/sáng tạo mới</option>
                  <option value="${OTHER}">Vấn đề khác</option>
                </select>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- Nếu category == colleague -->
    <div class="colleague-block list no-margin  display-none">
      <ul class="colleage-comment-form">
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">Bạn muốn góp ý về ai?</div>
            <div class="item-input-wrap input-dropdown">
              <select name="id_emp_victim">
                <option value="">Chọn đồng nghiệp</option>
              </select>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">Ý kiến/góp ý của bạn</div>
            <div class="item-input-wrap">
              <textarea name="comment" placeholder="Những lời góp ý thẳng thắn và mang tính xây dựng luôn luôn là những điều đáng được trân trọng." style="min-height: 250px;"></textarea>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <${BackButton}/>
          <${SendButton}/>
        </li>
      </ul>
    </div>

    <!-- Sau khi post góp ý với category == colleague || category == other -->

    <div class="comment-solution-block list no-margin  display-none">
      <ul class="comment-solution-form">
        <li class="item-content">
          <div class="item-inner">
            Cảm ơn bạn! Ý kiến/góp ý của bạn đã được gửi đi. Nếu là bạn khi giải quyết/xử lý vấn đề bạn vừa nêu ra, thì bạn sẽ làm như thế nào?
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">Em sẽ</div>
            <div class="item-input-wrap">
              <textarea name="comment_solution" placeholder="Hãy viết tất cả những gì bạn nghĩ nhé! Có thể đó chính là giải pháp tốt nhất!" style="min-height: 250px;"></textarea>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <${SendButton}/>
        </li>
      </ul>
    </div>

    <!-- Nếu category == idea -->

    <div class="newidea-block list no-margin  display-none">
      <ul class="newidea-form">
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">Bạn có ý tưởng/góp ý như thế nào?</div>
            <div class="item-input-wrap">
              <textarea name="comment" placeholder="Chỉ cần viết ra mà không cần sắp xếp, tất cả các ý tưởng của bạn đều có thể thành hiện thực." style="min-height: 250px;"></textarea>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <${BackButton}/>
          <${SendButton}/>
        </li>
      </ul>
    </div>

    <!-- Nếu category == other -->


    <div class="other-block list no-margin display-none">
      <ul class="other-form">
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">Bạn gặp vấn đề gì? Hãy chia sẻ nhé!</div>
            <div class="item-input-wrap">
              <textarea name="comment" placeholder="Chỉ cần viết ra thôi, vấn đề nào cũng có thể giải quyết được khi đã viết được ra." style="min-height: 250px;"></textarea>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <${BackButton}/>
          <${SendButton}/>
        </li>
      </ul>
    </div>

  </div>
</div>
`
    }
    ;
});